import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/',
    name: 'home',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Home.vue'),
    redirect: 'batch',
    children: [
      {
        path: 'batch',
        component: () => import(/* webpackChunkName: "about" */ '../views/Batch')
      },
      {
        path: 'admin',
        component: () => import(/* webpackChunkName: "about" */ '../views/Admin')
      },
      {
        path: 'cancel',
        component: () => import(/* webpackChunkName: "about" */ '../views/Cancel')
      },
      {
        path: 'scan',
        component: () => import(/* webpackChunkName: "about" */ '../views/Scan')
      },
      {
        path: 'coupon/:code',
        component: () => import(/* webpackChunkName: "about" */ '../views/Coupon')
      }
    ]
  },
]

const router = new VueRouter({
  routes
})

const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

export default router
